export const PreparePath = '/prepare';
